<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 12c-3.8 0-5.5-1.7-5.5-5.5S8.2 1 12 1s5.5 1.7 5.5 5.5S15.8 12 12 12m2.04 2.11q-.5.85-1.1 1.67.61 2 1 4.05A.96.96 0 0 1 13 21h-2a.96.96 0 0 1-.94-1.17c.2-1.29.56-2.62.98-3.99q-.62-.82-1.13-1.72c-4.5.54-6.65 3.02-6.9 7.83A1 1 0 0 0 4 23h16a1 1 0 0 0 1-1.05c-.26-4.82-2.43-7.3-6.96-7.84"/></svg>
</template>
